import { DeletingState, DeletingActions, TOGGLE_DELETING_PENDING } from "../types";


const initialState: DeletingState = {
  pending: false
}

export default function deletingReducer(state = initialState, action: DeletingActions): DeletingState {
  switch (action.type) {
    case TOGGLE_DELETING_PENDING:
      return {
        pending: !!action.pending
      }
    default:
      return state;
  }
}